import React, { useState } from 'react';
import FAQItem from './FaqItem'; // Adjust the import path as necessary
import DOMPurify from 'dompurify';

const FAQSection = ({ title, faqData, introduction='' }) => {
  const [openItems, setOpenItems] = useState(new Array(faqData.length).fill(false));
  const [allExpanded, setAllExpanded] = useState(false);
  
  const sanitizedIntroduction = DOMPurify.sanitize(introduction);
  
  // Toggle a single item
  const toggleItem = (index) => {
    const newOpenItems = [...openItems];
    newOpenItems[index] = !newOpenItems[index];
    setOpenItems(newOpenItems);
    
    // Update allExpanded state based on if all items are now open or not
    setAllExpanded(newOpenItems.every(item => item === true));
  };
  
  // Toggle all items at once
  const toggleAllItems = () => {
    const newState = !allExpanded;
    setAllExpanded(newState);
    setOpenItems(new Array(faqData.length).fill(newState));
  };
  
  return (
    <div className="w-full max-w-[1076px] mx-auto px-5 sm:px-6 lg:px-8">
      <div className="mb-[20px] md:mb-[30px] xxs:flex flex-wrap justify-between items-center">
        <span className="text-[28px] md:text-3xl lg:text-[50px] font-bold uppercase text-lightBlack">{title}</span>
        <button 
          onClick={toggleAllItems}
          className="flex xxs:ml-0 ml-auto xxs:mt-0 mt-[8px]   items-center px-4 py-2 bg-[#00066A] text-white rounded-lg transition-colors xs:text-[20px] xs:leading-8 text-[18px] leading-normal font-fira font-normal"
        >
          {allExpanded ? (
            <>
              <svg xmlns="http://www.w3.org/2000/svg"  className="xs:w-[20px] xs:h-[20px] w-[18px] h-[18px] mr-2" width="20" height="20" viewBox="0 0 22 21" fill="none">
                <path d="M11.0086 0.5C17.0674 0.5 22.0043 4.99461 22 10.5078C21.9957 16.021 17.0562 20.5016 10.9914 20.5C4.9266 20.4984 -0.0102923 15.996 1.61141e-05 10.4524C0.0103246 4.97664 4.96269 0.5 11.0086 0.5ZM11.0086 18.9432C12.8441 18.9417 14.6379 18.4455 16.1634 17.5174C17.6889 16.5893 18.8777 15.2709 19.5796 13.7287C20.2815 12.1866 20.465 10.4899 20.1069 8.85291C19.7489 7.21596 18.8653 5.71223 17.5679 4.53168C16.2704 3.35113 14.6172 2.54672 12.8173 2.22007C11.0173 1.89343 9.1512 2.05919 7.45477 2.69643C5.75835 3.33367 4.30769 4.4138 3.28603 5.80036C2.26437 7.18692 1.71754 8.81771 1.71465 10.4867C1.71148 11.5975 1.94961 12.698 2.41535 13.7249C2.88109 14.7518 3.56529 15.685 4.42866 16.4709C5.29203 17.2567 6.31758 17.8798 7.44645 18.3043C8.57532 18.7289 9.78528 18.9465 11.0069 18.9448L11.0086 18.9432Z" fill="white"/>
                <path d="M11.8599 9.64779H9.62641C8.69607 9.64779 7.76574 9.6431 6.8354 9.64779C6.33114 9.65169 5.99784 9.88213 5.91881 10.2586C5.80542 10.7882 6.17651 11.196 6.80532 11.196C7.90317 11.203 9.00103 11.196 10.1401 11.196H12.3736C13.3186 11.196 14.2635 11.2007 15.2084 11.196C15.7239 11.196 16.0675 10.9007 16.0924 10.4711C16.1173 10.0188 15.7909 9.68997 15.266 9.64701C15.0942 9.63373 14.9224 9.64232 14.7506 9.64232H11.8599" fill="white"/>
              </svg>
              Collapse All
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-[20px] xs:h-[20px] w-[18px] h-[18px] mr-2" width="20" height="20" viewBox="0 0 20 21" fill="none">
                <path d="M10.0053 0.5C15.5146 0.5 20.0037 4.99461 19.9998 10.5078C19.9959 16.021 15.5044 20.5016 9.98966 20.5C4.4749 20.4984 -0.0142417 15.996 -0.00486816 10.4524C0.00450538 4.97664 4.50772 0.5 10.0053 0.5ZM10.0053 18.9432C11.6743 18.9417 13.3054 18.4455 14.6926 17.5174C16.0797 16.5893 17.1607 15.2709 17.799 13.7287C18.4372 12.1866 18.6041 10.4899 18.2785 8.85291C17.9529 7.21596 17.1494 5.71223 15.9697 4.53168C14.7899 3.35113 13.2867 2.54672 11.6499 2.22007C10.0132 1.89343 8.31635 2.05919 6.77378 2.69643C5.23121 3.33367 3.91212 4.4138 2.98312 5.80036C2.05412 7.18692 1.55689 8.81771 1.55426 10.4867C1.55138 11.5975 1.76791 12.698 2.19141 13.7249C2.6149 14.7518 3.23705 15.685 4.02212 16.4709C4.80718 17.2567 5.73972 17.8798 6.76621 18.3043C7.7927 18.7289 8.89292 18.9465 10.0037 18.9448L10.0053 18.9432Z" fill="white"/>
                <path d="M10.7794 11.2015C10.7794 12.2294 10.7794 13.2035 10.7794 14.1776C10.7794 14.5681 10.6474 14.872 10.274 15.018C9.74441 15.2266 9.22965 14.8454 9.22262 14.2369C9.21168 13.3652 9.22262 12.4934 9.22262 11.6217V11.2015C8.18684 11.2015 7.19168 11.2069 6.19027 11.2015C5.62239 11.2015 5.28104 10.7914 5.38414 10.2641C5.45601 9.89072 5.7591 9.65716 6.21762 9.65326C7.06358 9.64545 7.90954 9.65326 8.75551 9.65326H9.22418V7.83401C9.22418 7.49578 9.22418 7.15755 9.22418 6.81855C9.22418 6.13115 9.48585 5.79371 10.0131 5.80308C10.524 5.80777 10.7802 6.14131 10.7817 6.8037C10.7817 7.61087 10.7817 8.41804 10.7817 9.2252V9.65248H13.4165C13.5727 9.65248 13.7289 9.64388 13.8852 9.65716C14.3624 9.69934 14.6593 10.029 14.6366 10.4813C14.6069 10.9062 14.2945 11.2015 13.8258 11.2015C12.9666 11.2085 12.1073 11.2015 11.2481 11.2015H10.7794Z" fill="white"/>
              </svg>
              Expand All
            </>
          )}
        </button>
      </div>
      
      {introduction && (
        <div 
          className='mt-5 mb-8 sm:text-lg md:text-xl lg:text-22px' 
          dangerouslySetInnerHTML={{ __html: sanitizedIntroduction }}
        />
      )}
      
      {faqData.map((faq, index) => (
        <FAQItem 
          key={index}
          title={faq.title}
          description={faq.description}
          isOpen={openItems[index]}
          onToggle={() => toggleItem(index)}
        />
      ))}
    </div>
  );
};

export default FAQSection;